import React from "react";
import { useDispatch } from "react-redux";
import {  KDialog } from "@kyburz/kdesign-system";
import { setAlert } from "../../../redux/actions/actions";
import { useDeleteIoTKeyCommand } from "../../../apiCalls/config/iotKeyCommands";

interface Props {
  showDeleteDialog: boolean;
  onCloseDialog: () => void;
  iotKeyCommand: { id: string, name: string } | undefined;
}

const IoTKeyCommands = ({
  showDeleteDialog,
  iotKeyCommand,
  onCloseDialog,
}: Props) => {
  const dispatch = useDispatch();

  const { request: handleDelete } = useDeleteIoTKeyCommand();

  return (
    <KDialog
      size="xs"
      title="Delete SMS Command"
      open={showDeleteDialog}
      primaryCTAonClick={() => {
        handleDelete(iotKeyCommand?.id)
          .then(() =>
            dispatch(
              setAlert(
                `SMS Command ${iotKeyCommand?.name} has been deleted`,
                "success",
              ),
            ),
          )
          .catch((response) =>
            dispatch(setAlert(`Delete failed! ${response?.details}`, "error")),
          )
          .then(onCloseDialog);
      }}
      primaryCTAColor="danger"
      primaryCTAText="Delete"
      secondaryCTAonClick={onCloseDialog}
      secondaryCTAText="Cancel"
    >
      <p>Are you sure you want to delete {iotKeyCommand?.name}?</p>
    </KDialog>
  );
};

export default IoTKeyCommands;
